import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-underline",
  "use": "icon-underline-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-underline\">\n\t<path fill=\"none\" d=\"M0,0H24V24H0Z\" />\n<path d=\"M9.5,6v5.43a2.39,2.39,0,0,0,2.5,2.5,2.39,2.39,0,0,0,2.5-2.5V6H16v5.43a4,4,0,0,1-8,0V6ZM6,16.48H18V18H6Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol